import { render } from "./SystemSettingComponents.vue?vue&type=template&id=07881655&scoped=true"
import script from "./SystemSettingComponents.vue?vue&type=script&lang=js"
export * from "./SystemSettingComponents.vue?vue&type=script&lang=js"

import "./SystemSettingComponents.vue?vue&type=style&index=0&id=07881655&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07881655"]])

export default __exports__